{
  "version": 1,
  "asset_id": "b1faa906-de0e-4635-9328-3427313746b9",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b1faa906-de0e-4635-9328-3427313746b9/hiatal-type-3-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b1faa906-de0e-4635-9328-3427313746b9/hiatal-type-3-v2-1200.webp",
  "original_filename": "hiatal-type-3-v2-1200.webp",
  "size": 165746,
  "content_type": "image/webp",
  "created_at": "2026-09-24T19:27:54Z"
}
